var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-card-loader"},[(_vm.loading)?_c('div',[_c('a-skeleton',{attrs:{"active":""}})],1):_c('div',[_c('data-empty')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }